import classNames from 'classnames'
import { FC } from 'react'
import { AudioLoaderProps } from './AudioLoader.model'
import styles from './AudioLoader.module.scss'

export const AudioLoader: FC<AudioLoaderProps> = ({ active }) => {
  return (
    <div className={classNames(styles.speechVisualizer, { [styles.active]: active })}>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
}
